import React from 'react'
import {Switch, Route} from 'react-router-dom'
import Login from './views/login.js'
import CSConnectApp from './views/cs-connect-app'
import {isAuthenticated} from './util/helpers'

export default () => (
  <Switch>
    <Route exact path='/' render={renderBasedonAuthenticationCheck}/>
    <Route path='/search' component={CSConnectApp}/>
    <Route path='*' render={(props) => {
      props.history.push('/')
      return null
    }}/>
  </Switch>
)

const renderBasedonAuthenticationCheck = (props) => {
  if (isAuthenticated()) {
    props.history.push('/search')
    return null
  }
  return <Login {...props}/>
}



// WEBPACK FOOTER //
// ./src/app.js